import { withProps, withHandlers, compose } from 'recompose'
import pick from 'lodash/pick'
import { connect } from 'react-redux'
import { hide, show } from 'redux-modal'
import { rest } from 'services'
import withHandlePhoneLinkClick from 'components/common/hoc/withHandlePhoneLinkClick'
import { isApptConfirmationPage, isQuoteSummaryPage } from 'helpers/quoteRelatedPages'
import { formatPhoneNumbers } from './helpers'
import AppointmentsLocationItem from './AppointmentsLocationItem'
import { getLocationPathname } from 'selectors/getPageLocation'
import { getCurrentStoreId } from 'selectors/getCurrentStore'
import { selectMyStore } from 'actions/storeLocator'
import { getIsOnlineAppointment } from 'components/QuickAppointmentPage/BOTAppointmentSummary/helpers'
import { getAppointmentFormValues } from 'components/AppointmentConfirmationPage/Checkout/selectors'
import { STORE_NOT_ELIGIBLE_FOR_PROMOTION_MODAL } from 'components/QuickAppointmentPage/ThreeStepper/constants'
import { STORE_LOCATOR_MODAL_PAGE } from 'constant'
import { resetCalendarStartDate } from 'components/common/hoc/withAddToQuote/actions'
import { setDateData } from 'components/QuickAppointmentPage/actions'

const mapStateToProps = (state, { storeId }) => {
  const pathname = getLocationPathname(state)
  const { activePromotions } = getAppointmentFormValues(state) || {}

  return {
    isSaved: getCurrentStoreId(state) === storeId,
    isCheckout: isApptConfirmationPage(pathname),
    storeId,
    isQuickAppointmentPage: getIsOnlineAppointment({ pathname }),
    activePromotions,
    isQuotePage: isQuoteSummaryPage(pathname)
  }
}

const withFormattedLocationDetails = withProps(({
  address: {
    zipcode,
    city,
    address1,
    state
  },
  phoneNumbers
}) => ({
  addressObject: {
    zipcode,
    city,
    address1,
    state
  },
  street: address1,
  address: `${city}, ${state} ${zipcode}`,
  phoneNumbers: formatPhoneNumbers(phoneNumbers)
}))

const withStoreSelectHandlers = withHandlers({
  selectStoreHandler: ({
    selectMyStore,
    handleTAOSDateTimeUpdate,
    storeId,
    isQuickAppointmentPage,
    activePromotions,
    street,
    address,
    show,
    hide,
    isQuotePage,
    resetCalendarStartDate,
    setDateData,
    ...props
  }) =>
    () => {
      const selectStore = () => selectMyStore(pick(props, ['storeNumber', 'addressObject', 'isCheckout', 'handleTAOSDateTimeUpdate', 'navigateToThreeStepper', 'externalIdLong', 'isPreExpanded']))
      if (isQuickAppointmentPage && activePromotions.length) {
        const payload = {
          promotion: activePromotions[0].promotionId,
          storeNumber: props.storeNumber
        }

        rest.api.checkServicePromoExclusiveFromStore(payload)
          .then(({ promoExcludedFromStore }) => {
            if (promoExcludedFromStore) {
              hide(STORE_LOCATOR_MODAL_PAGE)
              show(STORE_NOT_ELIGIBLE_FOR_PROMOTION_MODAL, { selectStore, storeAddress: `${street}, ${address}` })
            } else {
              selectStore()
            }
          })
          .catch(e => console.error(e))
      } else {
        if (isQuotePage) {
          resetCalendarStartDate()
          setDateData(null)
        }
        selectStore()
      }
    }
})

export default compose(
  withFormattedLocationDetails,
  connect(mapStateToProps, {
    selectMyStore,
    show,
    hide,
    resetCalendarStartDate,
    setDateData
  }),
  withStoreSelectHandlers,
  withHandlePhoneLinkClick
)(AppointmentsLocationItem)
